import FormGroup from '@material-ui/core/FormGroup';

const styles = () => ({
  item: {
    height: 53,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    '&:not(:last-child)': {
      boxShadow: 'inset 0 -1px 0 #f4f4f6',
    },
  },
});

class SwitchGroupItem extends React.Component {
  render() {
    let { classes, children, ...props } = this.props;

    return (
      <div className={classes.item} {...props}>
        {children}
      </div>
    );
  }
}

class SwitchGroup extends React.Component {
  render() {
    let { children, classes: _classes, ...props } = this.props;

    return <FormGroup {...props}>{children}</FormGroup>;
  }
}

const StyledSwitchGroup = withStyles(styles)(SwitchGroup);
const StyledSwitchGroupItem = withStyles(styles, {
  name: 'AppSwitchGroupItem',
})(SwitchGroupItem);

export default StyledSwitchGroup;
export { StyledSwitchGroupItem as SwitchGroupItem };
